
define('text!modules/reporting/segments/dataExport/createEdit/templates/segmentExport.html',[],function () { return '<div class="segment-export-wrapper">\n    {{#canSeeExports}}\n    <strand-button id="segment-export" type="primary" class="column">\n        <label>Segment Export</label>\n    </strand-button>\n    {{/canSeeExports}}\n</div>';});

